import { Ng2StateDeclaration } from '@uirouter/angular';
import { LoginComponent } from './containers/login/login.component';

export const indexState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'index',
    url: '/',
    component: LoginComponent
};

export const loginState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'login',
    url: '/login',
    component: LoginComponent
};

export const AUTH_STATES = [
    indexState,
    loginState
];
